import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { RouterLink } from "@angular/router";
import { TitleChange } from '../services/title-change';
import { Link } from "../directives/link";

@Component({
  selector: 'app-marcion',
  imports: [RouterLink, Link],
  templateUrl: './marcion.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './marcion.scss',
})
export class Marcion {
  dynamicTitle = inject(TitleChange);
  
  constructor() {
    this.dynamicTitle.title(`Marcion of Sinope`);
    this.dynamicTitle.description(`Marcion was a 2nd-century Christian theologian and the founder of Marcionism. He also published the first Biblical canon.`);
  }
}
